import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(numeroFicha,numeroProforma , numPedidoVeh,codFiveBono, canValeBono, montoVale, montoValeTotal, codEstaVale, bonoObservaciones, notificadores) {
    const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
    };

    const data ={
      canValeBono: canValeBono,
      codEstadoVale: codEstaVale,
      codFiveBono: codFiveBono,
      codUsuario: IDUSUARIO,
      montoVale: montoVale,
      montoValeTotal: montoValeTotal,
      numFichaVtaVeh: numeroFicha,
      numPedidoVeh: numPedidoVeh,
      numProfVeh: numeroProforma,
      bonoObservaciones:bonoObservaciones,
      codColaborador:notificadores,
    }


  return customAxios.post(`${FDV_URL}/ficha-venta/fichas-ventas/${numeroFicha}/proformas/${numeroProforma}/bonos-vales`,data, config);

}



// WEBPACK FOOTER //
// ./src/utils/addBonosVale.js